import React from "react"
import Layout from "./../../../shared/components/organisms/layout/layout"
import SEO from "./../../../shared/seo"
import ModalViewer from "./../../organisms/modal-viewer/modal-viewer"
import useMediaQuery from "./../../../utils/useMediaQuery"
import NavMenu from '../../organisms/navMenu/navMenu'

import { title, description } from "./../../../constants/activity-seo"

import "./page-layout.scss"
export default function PageLayout({ hiddenNav, children }) {
  const isMobile = useMediaQuery()
  return (
    <Layout mobile={isMobile}>
      <SEO title={title} description={description} />
      <ModalViewer />
      <div className="f-personajes-layout">
        {!hiddenNav && <NavMenu isMobile={isMobile} />}
        <div className="f-personajes-layout__container">{children}</div>
      </div>
    </Layout>
  )
}
